(function () {'use strict';}());

angular.module("app").directive('assessmentView', function($document,$timeout) {
	return {
	  restrict: 'A',
	  templateUrl: 'views/weekly-assessment.html?version=1.0',

	  link:function($scope,element,attr)
	  {
	    var trace = angular.trace;
	  }  
	};
});

angular.module("app").directive('assessmentLandingView', function($document,$timeout) {
	return {
	  restrict: 'A',
	  templateUrl: 'views/weekly-assessment-landing.html?version=1.0',

	  link:function($scope,element,attr)
	  {
	    var trace = angular.trace;
	  }  
	};
});

angular.module("app").directive('assessmentQuestionView', function($document,$timeout) {
	return {
	  restrict: 'A',
	  templateUrl: 'views/weekly-assessment-question.html?version=1.0',

	  link:function($scope,element,attr)
	  {
	    var trace = angular.trace;
	  }  
	};
});

angular.module("app").directive('assessmentFeedbackLandingView', function($document,$timeout) {
	return {
	  restrict: 'A',
	  templateUrl: 'views/weekly-assessment-feedback-landing.html?version=1.0',

	  link:function($scope,element,attr)
	  {
	    var trace = angular.trace;
	  }  
	};
});

angular.module("app").directive('assessmentFeedbackView', function($document,$timeout) {
	return {
	  restrict: 'A',
	  templateUrl: 'views/weekly-assessment-feedback.html?version=1.0',

	  link:function($scope,element,attr)
	  {
	    var trace = angular.trace;

	    $scope.$watch("currentTip",function(value){
	    	if(value) element.closest("#app-container").scrollTop(0);
	    });
	  }  
	};
});

angular.module("app").directive('assessmentChartView', function($document,$timeout) {
	return {
	  restrict: 'A',
	  templateUrl: 'views/weekly-assessment-chart.html?version=1.0',

	  link:function($scope,element,attr)
	  {
	    var trace = angular.trace;

	    $scope.$watch("currentTip",function(value){
	    	if(value) element.closest("#app-container").scrollTop(0);
	    });
	  }  
	};
});